import { NavLink, Outlet } from "react-router-dom";
import { LayoutDashboard, ShoppingBag, Package, Layers, Archive, Tag, MessageSquare } from "lucide-react";
import "./AdminLayout.css";

export default function AdminLayout() {
  return (
    <div className="admin-shell">
      <div className="admin-shell__inner">
        <aside className="admin-sidebar">
          <h1 className="admin-sidebar__title">Admin</h1>
          <p className="admin-sidebar__sub">Store management</p>
          <nav className="admin-nav">
            <NavLink end to="/admin" className={({ isActive }) => (isActive ? "active" : "")}>
              <LayoutDashboard size={16} />
              <span>Overview</span>
            </NavLink>
            <NavLink to="/admin/orders" className={({ isActive }) => (isActive ? "active" : "")}>
              <ShoppingBag size={16} />
              <span>Orders</span>
            </NavLink>
            <NavLink to="/admin/products" className={({ isActive }) => (isActive ? "active" : "")}>
              <Package size={16} />
              <span>Products</span>
            </NavLink>
            <NavLink to="/admin/collections" className={({ isActive }) => (isActive ? "active" : "")}>
              <Layers size={16} />
              <span>Collections</span>
            </NavLink>
            <NavLink to="/admin/coupons" className={({ isActive }) => (isActive ? "active" : "")}>
              <Tag size={16} />
              <span>Coupons</span>
            </NavLink>
            <NavLink to="/admin/stock" className={({ isActive }) => (isActive ? "active" : "")}>
              <Archive size={16} />
              <span>Stock</span>
            </NavLink>
            <NavLink to="/admin/inquiries" className={({ isActive }) => (isActive ? "active" : "")}>
              <MessageSquare size={16} />
              <span>Inquiries</span>
            </NavLink>
          </nav>
        </aside>
        <main className="admin-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
